import { Component, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { NgbOffcanvas } from '@ng-bootstrap/ng-bootstrap';
import { BillingManagementService } from 'src/service/billing-management.service';
import { ConfigurationManagementService } from 'src/service/configuration-management.service';
import { LanguageManagementService } from 'src/service/language-management.service';
import { FocusInputType, GeneralConfigType, KeyValueSet, LocalService, ReceiptOption, ReceiptOptionGroup, Status } from 'src/service/local.service';

@Component({
  selector: 'app-receipt-options',
  templateUrl: './receipt-options.component.html',
  styleUrl: './receipt-options.component.scss'
})
export class ReceiptOptionsComponent {
  @ViewChild('content_receipt_options')
  content!: TemplateRef<any>;
  @Input() isOpenPopup: boolean = false;
  @Output() isOpenPopupChange = new EventEmitter();
  @Output() onClose = new EventEmitter();

  lstSectionConfigKeys: string[] = ["seller"];
  elementIds: any; htmlId: string = '';

  @Input() businessId: string = ''; @Input() receiptType: number | string = 0;
  searchKey = ''; isPrint = false; printingLanguageId = ''; selectedReceiptOptionsForPrint: ReceiptOption[] = [];
  sourcerReceiptOptions: KeyValueSet[]; receiptOptions: KeyValueSet[]; currentReceiptOptions: ReceiptOption[]; isSortByName = true;

  constructor(private offcanvasService: NgbOffcanvas, public localService: LocalService, private languageManagementService: LanguageManagementService, public billingManagementService: BillingManagementService, public configurationManagementService: ConfigurationManagementService) {
    this.htmlId = this.localService.getRandomString(5);
    this.elementIds = {
      txt_search_key: 'txt_search_key_' + this.htmlId,
      print_language: 'print_language_' + this.htmlId
    };
  }

  ngOnInit(): void {
    this.printingLanguageId = this.localService.getLanguageId(this.localService.selectedLanguageCode);
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    if (!this.localService.receiptOptions) {
      this.configurationManagementService.getConfigurationsToDisplay(GeneralConfigType.ReceiptOption, true).subscribe(result => {
        this.localService.receiptOptions = result;
        this.sourcerReceiptOptions = result;
      });
    } else {
      this.sourcerReceiptOptions = this.localService.receiptOptions;
    }
  }

  ngOnChanges(): void {
    if (this.isOpenPopup) {
      this.onLoad();
      this.offcanvasService.open(this.content, {
        position: 'end',
        backdrop: 'static',
        keyboard: false,
        animation: true,
        panelClass: 'popup_overlay_right',
        beforeDismiss: this.onBeforeDismiss
      });
    }
  }

  onBeforeDismiss(): boolean {
    this.isOpenPopup = false;
    if (this.isOpenPopupChange) {
      this.isOpenPopupChange.emit(this.isOpenPopup);
    }
    return true;
  }

  onCloseTrigger(event?: any) {
    this.onReset();
    this.onClose.emit(event);
    this.onBeforeDismiss();
    this.offcanvasService.dismiss();
  }

  onReset() {
    if (this.sourcerReceiptOptions && this.currentReceiptOptions) {
      this.sourcerReceiptOptions.forEach(item => {
        item.isSelected = this.currentReceiptOptions.includes(parseInt(item.key));
      });
    }
  }

  onLoad() {
    if (this.sourcerReceiptOptions && !this.currentReceiptOptions) {
      this.sourcerReceiptOptions = this.localService.Sort(this.sourcerReceiptOptions, true, "value");
      this.billingManagementService.getReceiptOptionsForBusiness(this.businessId).subscribe(result => {
        this.currentReceiptOptions = result;

        this.sourcerReceiptOptions.forEach(item => {
          item.isSelected = this.currentReceiptOptions.includes(parseInt(item.key));
        });

        this.receiptOptions = this.sourcerReceiptOptions.map(function (result) {
          return {
            key: result.key,
            value: result.value,
            isSelected: result.isSelected,
          } as KeyValueSet;
        });
        this.onEnableDisableDuplicate();
      });
    }
  }

  onAction(index: number, key?: string) {
    switch (index) {
      case 1: {
        //Search
        if (this.sourcerReceiptOptions) {
          let searchKey = this.searchKey.trim().toLowerCase();
          let items = searchKey != '' ? this.sourcerReceiptOptions.filter(x => x.key.indexOf(searchKey) > -1 || x.value.toLowerCase().indexOf(searchKey) > -1 || (x.s_value && x.s_value.indexOf(searchKey) > -1)) : this.sourcerReceiptOptions;
          this.receiptOptions = items.map(function (result) {
            return {
              key: result.key,
              value: result.value,
              isSelected: result.isSelected
            } as KeyValueSet;
          });
          this.onEnableDisableDuplicate();
          this.localService.onFocusNextInput(this.elementIds.txt_search_key, FocusInputType.TextBox);
        }
      } break;
      case 2: {
        //Save
        const temp: ReceiptOption[] = this.sourcerReceiptOptions.filter(x => x.isSelected).map(x => parseInt(x.key));
        this.billingManagementService.saveReceiptOptions(this.businessId, temp).subscribe(result => {
          this.localService.showInformationByStatus(result.status);
          if (result.status == Status.Success) {
            this.currentReceiptOptions = temp;
            this.onCloseTrigger();
          }
        });
      } break;
      case 3: {
        //Update source
        this.onEnableDisableDuplicate();
        this.sourcerReceiptOptions.find(x => x.key == key).isSelected = this.receiptOptions.find(x => x.key == key).isSelected;
      } break;
      case 4: {
        //Print sample        
        this.isPrint = false;
        setTimeout(() => {
          this.selectedReceiptOptionsForPrint = this.sourcerReceiptOptions.filter(x => x.isSelected).map(x => parseInt(x.key));
          this.isPrint = true;
        }, 100);
      } break;
      case 5: {
        this.isSortByName = !this.isSortByName;
        this.sourcerReceiptOptions = this.localService.Sort(this.sourcerReceiptOptions, true, this.isSortByName ? "value" : 'key', !this.isSortByName);
        this.receiptOptions = this.localService.Sort(this.receiptOptions, true, this.isSortByName ? "value" : 'key', !this.isSortByName);
        this.onEnableDisableDuplicate();
      } break;
    }
  }

  onPrinted() {
    this.isPrint = false;
  }

  onEnableDisableDuplicate() {
    const lstReceiptOptionGroups: number[] = Object.keys(ReceiptOptionGroup).map(x => parseInt(x)).filter(x => x || x == 0);
    const receiptOptionsTextsSelected = this.receiptOptions.filter(x => x.isSelected).map(receiptOption => ReceiptOption[parseInt(receiptOption.key)]);
    this.receiptOptions.filter(x => !x.isSelected).forEach(receiptOption => {
      const receiptOptionsText = ReceiptOption[parseInt(receiptOption.key)];
      lstReceiptOptionGroups.forEach(receiptOptionGroup => {
        const currentGroup = '__' + receiptOptionGroup;
        if (receiptOptionsText.endsWith(currentGroup)) {
          receiptOption.isInActive = receiptOptionsTextsSelected.filter(x => x.endsWith(currentGroup)).length > 0;
        }
      });
    });
  }
}
